/**
 * Main owns the whole order and calls it ready for pickup. Every other display only
 * finishes the preparation work routed to that station.
 */
export function completeSlipForDisplay<TOrder, TPreparation>(kitchenDisplayId: string, finishOrders: () => TOrder, finishPreparation: () => TPreparation): TOrder | TPreparation {
  return kitchenDisplayId === 'main' ? finishOrders() : finishPreparation()
}
